import React from "react";
const PlayerCard = ({ title, children }) => {
  return (
    <div className="player_card">
      <div className="leg_head">
        <h2>{title}</h2>
      </div>
      {children}
    </div>
  );
};

export default PlayerCard;
